export const purchaseTypes = [
  { id: 0, value: "Consumables" },
  { id: 1, value: "Software" },
  { id: 2, value: "Equipment" },
  { id: 3, value: "Capital Expense" },
  { id: 4, value: "Other" },
];

export const statusValues = [
  { value: 0, text: "New" },
  { value: 1, text: "Supervisor Approved" },
  { value: 2, text: "Business Manager Approved" },
  { value: 3, text: "With Legal" },
  { value: 4, text: "PO Entered" },
  { value: 5, text: "PO Sent To Vendor" },
  { value: 7, text: "Cancelled" },
  { value: 8, text: "On Hold" },
];

export const deadlineTypes = [
  { value: 0, text: "Standard" },
  { value: 2, text: "Urgent" },
  { value: 3, text: "No Rush" },
];

export const booleanTypes = [
  { value: true, text: "AS9100" },
  { value: false, text: "" },
];

export const booleanRender = (boolean) => {
  if (boolean === true) {
    return <span className="label label-warning">AS9100</span>;
  }
};

export const handledDateRender = (e) => {
  if (e.data.orderHandled === "0001-01-01T00:00:00") {
    return "N/A";
  } else {
    return e.text;
  }
};

export const urgencyRender = (deadline) => {
  switch (deadline) {
    case 0:
      return <span className="label label-warning">Standard</span>;
    case 2:
      return <span className="label label-danger">Urgent</span>;
    case 3:
      return <span className="label label-info">No Rush</span>;
    default:
      return null;
  }
};

export const statusRender = (status) => {
  switch (status) {
    case 0:
      return <span className="label label-new">New</span>;
    case 1:
      return (
        <span className="label label-supervisor">Supervisor Approved</span>
      );
    case 2:
      return (
        <span className="label label-business">Business Manager Approved</span>
      );
    case 3:
      return <span className="label label-legal">With Legal</span>;
    case 4:
      return <span className="label label-po-entered">PO Entered</span>;
    case 5:
      return <span className="label label-po-sent">PO Sent to Vendor</span>;
    case 7:
      return <span className="label label-cancelled">Cancelled</span>;
    case 8:
      return <span className="label label-hold">On Hold</span>;
    default:
      return null;
  }
};
